import axios from 'axios';
import { call, put, select } from 'redux-saga/effects';
import API from '../../constants/api';
import {
    getErrorMessage,
    isValidTextAndNotEmpty,
} from '../../constants/CommonUtil';
import { getStringFromObject } from '../../constants/lodashUtils';
import { isObjectValidAndNotEmpty } from '../../constants/nullCheckUtils';
import { fetchMachineIdSilently, getRegisteredMachineDetails } from '../../constants/registeredMachineUtils';
import { ERROR_MESSAGE } from '../../redux/modules/message/message-actions';
import {
    FETCH_REGISTERED_MACHINE_FAILURE,
    FETCH_REGISTERED_MACHINE_SUCCESS,
} from '../../redux/modules/registeredMachine/registeredMachine-actions';
import { HIDE_SPINNER, SHOW_SPINNER } from '../../redux/modules/spinner/spinner';

export default function* fetchRegisteredMachineDetailsWorker() {
    try {
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const appConfiguration = yield select(state => getStringFromObject('appConfiguration', state));
        const isRegisteredMachineEnabled = getStringFromObject('enable_registered_machine', appConfiguration);
        const printConnectConfig = getStringFromObject('printConnectConfig', appConfiguration);
        if (!isRegisteredMachineEnabled) {
            return;
        }
        let registeredMachineDetails = getRegisteredMachineDetails();
        if (!isObjectValidAndNotEmpty(registeredMachineDetails)) {
            const machineId = yield call(fetchMachineIdSilently, printConnectConfig);
            if (!isValidTextAndNotEmpty(machineId)) {
                return;
            }
            const response = yield call(axios.get, API.REGISTERED_MACHINE.GET_DETAILS, {
                params: {
                    machineId,
                },
            });
            registeredMachineDetails = response.data;
        }
        yield put({
            type: FETCH_REGISTERED_MACHINE_SUCCESS,
            registeredMachineDetails,
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (error) {
        console.error('Failed to fetch registered machine', error);
        yield put({ type: FETCH_REGISTERED_MACHINE_FAILURE });
        yield put({
            type: ERROR_MESSAGE,
            message: `Failed to fetch registered machine: ${getErrorMessage(error)}`,
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}
